import Button from "@mui/material/Button";
import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { DateTime } from "luxon";
import mixpanel from "mixpanel-browser";
import { FormikHelpers } from "formik";

import { traysApi } from "../services/api/trays";
import { goBackOrTo } from "../utils/history";
import { ErrorContext } from "../components/app-routes";
import Page from "../components/page";
import TrayForm, { TrayFormValues } from "../components/tray-form";
import LoadingBackdrop from "../components/loading-backdrop";
import StickyActionBar from "../components/sticky-action-bar";
import { Unit } from "../models/unit";
import { unitsApi } from "../services/api/units";

export default function AddTrayPage() {
  const history = useHistory();
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);
  const { handleError } = useContext(ErrorContext);
  const [units, setUnits] = useState<Unit[] | null>(null);

  const onSubmit = async (
    values: TrayFormValues,
    _helpers: FormikHelpers<TrayFormValues>,
  ) => {
    setBusy(true);

    try {
      await traysApi.add({
        id: 0,
        name: values.name,
        soilPerTray:
          values.soilPerTray === "" ? null : Number(values.soilPerTray),
        unit: values.unit,
        notes: values.notes,
        archivedAt: values.archived ? DateTime.now().toISO() : null,
      });

      mixpanel.track("Add Tray");

      setSaved(true);
    } catch (error) {
      handleError(error);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (saved) {
      history.replace("/home/trays");
    }
  }, [saved, history]);

  const getUnits = async () => {
    try {
      const units = await unitsApi.getAll();
      setUnits(units);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    getUnits();
  }, []);

  return (
    <Page title="Add Tray">
      {units && (
        <TrayForm
          initialValues={{
            id: 0,
            name: "",
            soilPerTray: "",
            unit: "Litres",
            notes: "",
            archived: false,
          }}
          unitOptions={(units ?? []).filter((unit) => unit.archivedAt === null)}
          onUnitsChanged={getUnits}
          onSubmit={onSubmit}
          saved={saved}
        >
          <StickyActionBar position="bottom">
            <Button
              variant="outlined"
              disabled={busy}
              onClick={() => goBackOrTo(history, "/home/trays")}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={busy}
            >
              Add
            </Button>
          </StickyActionBar>
        </TrayForm>
      )}
      <LoadingBackdrop open={busy} />
    </Page>
  );
}
